/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {registerProps as ɵa} from './widgets/common/container/container.props';
export {registerProps as ɵb} from './widgets/common/item-template/item-template.props';
export {registerProps as ɵd} from './widgets/common/message/message.props';
export {registerProps as ɵe} from './widgets/common/partial/partial.props';
export {registerProps as ɵc} from './widgets/common/repeat-template/repeat-template.props';